








































import { Component, Prop, Vue } from 'vue-property-decorator';
import PagesCoreView from './components/core/View.vue';
import PagesCoreFooter from './components/core/Footer.vue';

@Component({
  components: {
    PagesCoreView,
    PagesCoreFooter,
  },
})
export default class PagesIndex extends Vue {
  created() {
    this.$vuetify.theme.dark = true;
  }

  beforeDestroy() {
    this.$vuetify.theme.dark = false;
  }
}
